import React from 'react';
import { Header } from 'widgets';
import { PageLayout } from 'shared/ui';
import styles from './terms-of-service.page.module.scss';

export const TermsOfServicePage: React.FC = () => {
  return (
    <PageLayout>
      <Header hideSignInButton />
      <div className={styles.page__content}>
        <h1 className={styles.content__title}>Пользовательское соглашение</h1>
        <p className={styles.content__date}>
          Дата вступления в силу: 17.06.2026
        </p>
        <p className={styles.content__operator}>
          Оператор: Самозанятый, ИНН 212710062014
        </p>

        <section className={styles.content__section}>
          <h2>1. Термины и определения</h2>
          <p>
            1.1. Сервис — программно-аппаратный комплекс BookUp, предоставляющий
            возможности для управления бронированием услуг и записи клиентов.
          </p>
          <p>
            1.2. Пользователь — любое физическое или юридическое лицо,
            использующее Сервис.
          </p>
          <p>
            1.3. Администратор — Пользователь, зарегистрированный в Сервисе в
            качестве владельца бизнеса или администратора точки оказания услуг.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>2. Предмет соглашения</h2>
          <p>
            2.1. Настоящее Соглашение регулирует отношения между Оператором
            Сервиса и Пользователем по использованию функциональных возможностей
            Сервиса.
          </p>
          <p>
            2.2. Используя Сервис, Пользователь подтверждает, что ознакомился с
            условиями настоящего Соглашения и принимает их в полном объеме.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>3. Регистрация и учетная запись</h2>
          <p>
            3.1. Для доступа к функциям Сервиса Пользователь должен пройти
            процедуру регистрации с указанием достоверных данных.
          </p>
          <p>
            3.2. Пользователь несет ответственность за сохранность своих учетных
            данных и за все действия, совершенные под его учетной записью.
          </p>
          <p>
            3.3. Оператор имеет право заблокировать учетную запись Пользователя
            при нарушении условий настоящего Соглашения.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>4. Права и обязанности сторон</h2>
          <p>4.1. Оператор обязуется:</p>
          <ul>
            <li>Обеспечивать работоспособность Сервиса;</li>
            <li>Обеспечивать сохранность данных Пользователя;</li>
            <li>Информировать Пользователя об изменениях в Соглашении.</li>
          </ul>
          <p>4.2. Пользователь обязуется:</p>
          <ul>
            <li>Предоставлять достоверную информацию при регистрации;</li>
            <li>Не использовать Сервис для противоправных целей;</li>
            <li>
              Не предпринимать попыток взлома или нарушения безопасности
              Сервиса.
            </li>
          </ul>
        </section>

        <section className={styles.content__section}>
          <h2>5. Интеллектуальная собственность</h2>
          <p>
            5.1. Все исключительные права на Сервис, включая программный код,
            дизайн, логотип и товарный знак, принадлежат Оператору.
          </p>
          <p>
            5.2. Никакие права на интеллектуальную собственность не переходят к
            Пользователю в результате использования Сервиса.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>6. Ограничение ответственности</h2>
          <p>
            6.1. Сервис предоставляется «как есть» (as is). Оператор не
            гарантирует бесперебойную работу Сервиса и не несет ответственности
            за возможные убытки, связанные с его использованием.
          </p>
          <p>
            6.2. Оператор не несет ответственности за действия третьих лиц,
            включая других Пользователей Сервиса.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>7. Заключительные положения</h2>
          <p>
            7.1. Настоящее Соглашение регулируется законодательством Российской
            Федерации.
          </p>
          <p>
            7.2. Споры, возникающие в рамках настоящего Соглашения, разрешаются
            путем переговоров, а при недостижении согласия — в судебном порядке
            по месту нахождения Оператора.
          </p>
          <p>
            7.3. Оператор имеет право в одностороннем порядке изменять условия
            Соглашения с предварительным уведомлением Пользователей.
          </p>
          <p>
            7.4. По всем вопросам, связанным с Соглашением, обращайтесь по
            адресу: support@book-up.ru.
          </p>
        </section>
      </div>
    </PageLayout>
  );
};
